"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataCallbackVisitor = void 0;
const odata_expression_visitor_1 = require("./odata-expression-visitor");
/**
 * Visits every node in an AST and calls the callback function
 *
 * @class ODataCallbackVisitor
 * @extends odata.ast.Visitor
 */
class ODataCallbackVisitor extends odata_expression_visitor_1.ODataExpressionVisitor {
    constructor(callbackFunc) {
        super();
        this.callbackFunc = callbackFunc;
        this.visitPropertyNode = this.visitPropertyNode.bind(this);
        this.visitLiteralNode = this.visitLiteralNode.bind(this);
        this.visitFunctionCallNode = this.visitFunctionCallNode.bind(this);
        this.visitBinaryExpressionNode = this.visitBinaryExpressionNode.bind(this);
        this.visitConditionalNode = this.visitConditionalNode.bind(this);
    }
    visitPropertyNode(node) {
        this.callbackFunc(node);
    }
    visitLiteralNode(node) {
        this.callbackFunc(node);
    }
    visitFunctionCallNode(node) {
        this.callbackFunc(node);
        for (const arg of node.args) {
            this.visit(arg);
            this.visit(arg);
        }
    }
    visitBinaryExpressionNode(node) {
        this.callbackFunc(node);
        this.visit(node.left);
        this.visit(node.right);
    }
    visitConditionalNode(node) {
        this.callbackFunc(node);
        this.visit(node.left);
        this.visit(node.right);
    }
}
exports.ODataCallbackVisitor = ODataCallbackVisitor;
//# sourceMappingURL=odata-callback-visitor.js.map